// ============================================
// R2 资源配置
// ============================================
// 这里集中管理所有存储在 Cloudflare R2 上的资源 URL
// 避免在构建时打包这些大文件

// ============================================
// 调试配置：切换本地/远程资源
// ============================================
// true  = 使用 R2 远程资源
// false = 使用本地打包资源 (从 dist/IsekaiRPG/resources/ 目录)
const USE_R2_RESOURCES = false;

// 你的 R2 公共访问域名 (请替换为实际域名)
// 注意：末尾不要带斜杠
// 示例：https://cdn.example.com
const R2_BASE_URL = 'https://kitakamis.online/IsekaiRPG/resources';

// 辅助函数：根据配置构建 URL
const getUrl = (path: string) => {
  const cleanPath = path.replace(/^\//, '');
  if (USE_R2_RESOURCES) {
    return `${R2_BASE_URL}/${cleanPath}`;
  } else {
    // 本地资源：使用打包后的资源目录
    // webpack 会自动将 src/IsekaiRPG/resources 复制到 dist/IsekaiRPG/resources
    return `./resources/${cleanPath}`;
  }
};

export const r2Resources = {
  // 音频资源
  audio: {
    openingBgm: getUrl('audio/opening_bgm.mp3'),
  },

  // 字体资源
  fonts: {
    alimama: getUrl('fonts/AlimamaFangYuanTiVF-Thin-2.woff2'),
  },

  // 地图数据
  maps: {
    statesData: getUrl('maps/data/States.csv'),
    citysData: getUrl('maps/data/Citys.csv'),

    // GeoJSON 数据
    mainlandCellsSmooth: getUrl('maps/Mainland_cellsSmooth.geojson'),

    // 海岸线数据 (不同精度)
    mainlandCoast05: getUrl('maps/Mainland_coast05.geojson'),
    mainlandCoast13: getUrl('maps/Mainland_coast13.geojson'),
    mainlandCoast25: getUrl('maps/Mainland_coast25.geojson'),
    mainlandCoast50: getUrl('maps/Mainland_coast50.geojson'),
    mainlandCoast100: getUrl('maps/Mainland_coast100.geojson'),

    // 其他地理数据
    mainlandRiversProcessed: getUrl('maps/Mainland_rivers_processed.geojson'),
    mainlandRoutes: getUrl('maps/Mainland_routes_processed.geojson'),
  },

  // 图片资源
  pictures: {
    welcomeBackground: getUrl('pictures/WelcomeView_Background_1.png'),
    tavernBackground: getUrl('pictures/background/background_Tavern.png'),
    villageBackground: getUrl('pictures/background/background_Village.png'),
  },
} as const;
